export default __webpack_public_path__ + "static/media/joel02.c72accbb.png";